export const educationData = [
    {
        id: 1,
        institution: 'Motilal Nehru National Institute of Technology, Allahabad',
        course: 'Bachelor of Technology',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'Jawahar Navodaya Vidyalaya, Vidisha',
        course: 'Higher secondary',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'Jawahar Navodaya Vidyalaya, Vidisha',
        course: 'High school',
        startYear: '2012',
        endYear: '2017'
    },
]